<template>
  <div :class="['dashboard', { 'height-100' : !comp_route.scroll }]">
    <a-layout class="height-100">
      <a-layout-header class="flex">
        <img src="@/assets/logo.png" class="logo inline-block mr4" />

        <div class="mobile-header">
          <h2><i :class='`uil uil-${comp_route.icon}`'></i>{{ comp_route.name }}</h2>
        </div>

        <div :class="[`menu inline-block col-12`, { 'is-open' : data_menuOpen }]">
          <img src="@/assets/logo.png" class="menu-logo" />
          <a-menu class="inline-block" theme="dark" mode="horizontal" :defaultSelectedKeys="['cohort']">
            <a-menu-item v-for="route in routes" :key="route.id" @click="data_menuOpen = false">
              <router-link :to="`/dashboard/${route.id}`"><i :class='`uil uil-${route.icon}`'></i>{{ route.name }}</router-link>
            </a-menu-item>
          </a-menu>
          <a-menu class="inline-block right" theme="dark" mode="horizontal">
            <a-menu-item @click="func_logout">
              <i class='uil uil-sign-out-alt'/>Logout
            </a-menu-item>
          </a-menu>
        </div>

        <div :class="[`hamburger-menu`, { 'is-open' : data_menuOpen }]" @click="data_menuOpen = !data_menuOpen">
          <i class='closed uil uil-bars'></i>
          <i class='opened uil uil-multiply'></i>
        </div>
          
      </a-layout-header>
      <a-layout-content>
        <template v-if="!loading">
            <router-view :taskOptions="taskOptions" :user="user" :isTrainee="comp_isTrainee"></router-view>
        </template>
        
        <!-- <page-content :key="$route.params.type" :options="currentPage" @change="currentPage.onChange" :chart-data="chartData" /> -->
      </a-layout-content>
    </a-layout>
  </div>
</template>

<script>
const taskOptions = [
  { label: 'Average time', value: 'averageTime'},
  { label: 'Last time', value: 'lastTime'},
  { label: 'Best time', value: 'bestTime'}
]

export default {
  name: 'Dashboard',
  data() {
    return {
      data_menuOpen: false,
      loading: true,
      user: {},
      institution: [],
      routes: [
        { id: 'cohort', name: 'Cohort', icon: 'adjust-circle' },
        { id: 'tasks', name: 'Rank', icon: 'star', scroll: true },
        { id: 'student', name: 'Student', icon: 'user' }
      ],
      taskOptions: taskOptions
    }
  },
  computed: {
    comp_isTrainee() {
      return this.user.accessLevel === 'trainee';
    },
    comp_route() {
      return this.routes.find(({id}) => this.$route.path.replace('/dashboard/', '') === id)
    }
  },
  methods: {
    func_logout() {
      this.$router.push('/logout')
    },
    func_getUser() {
      this.$services.users.getById(this.$user.uid).then((doc) => {
        const userData = doc.data();
        if (!userData.institution) this.$router.push('/register/personal-details');
        this.user = userData;
        this.loading = false;
      }).catch((err) => {
        this.$message.error(err);
        this.loading = false;
      })
    }
  },
  created() {
    this.func_getUser()
  }
}
</script>

<style lang="less" scoped>
.logo {
  max-width: 160px;
}
.ant-layout-header {
  position: sticky;
  top:0;
  border-bottom: 1px solid #30306E;
  background-color: #2B2A6C;
  z-index: 999;
  -webkit-transform:translateZ(1px);
  -moz-transform:translateZ(1px);
  -o-transform:translateZ(1px);
  transform:translateZ(1px);
}
.ant-layout-content {
  padding: @layout-header-padding;
}
.ant-menu-horizontal {
  line-height: 30px;
  .ant-menu-item {
    padding: 0 15px;
    a {
      transition: .2s ease border-color, .2s ease color;
      border-bottom: 2px solid @secondary-color;
      line-height: 30px;
      i {
        margin-right: 5px;
      }
      &.router-link-active {
        border-color: @primary-color;
      }
    }
  }
}
.filter-select {
  margin: 0 1em 0 0;
  &.right {
    margin: 0 0 0 1em;
  }
}
.ant-form-item {
  display: inline-block;
  color: #fff;
}
/deep/.ant-select-selection {
  background-color: #403F7A;
  border: none;
  padding: 8px;
  height: auto;
  .ant-select-arrow {
    color: #fff;
  }
  .ant-select-selection-selected-value {
     color: #fff;
  }
}
</style>

